export default __webpack_public_path__ + "static/media/1378.8b7336ec.png";